import React , { Suspense }from "react";
import ReactDOM from "react-dom";
// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
// plugins styles downloaded
import "assets/vendor/sweetalert2/dist/sweetalert2.min.css";
import "assets/vendor/select2/dist/css/select2.min.css";
import "assets/vendor/quill/dist/quill.core.css";
import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
// core styles
import "assets/scss/argon-dashboard-pro-react.scss?v1.0.0";
import 'react-toastify/dist/ReactToastify.css';
import "assets/css/ccl.css";

import { AppContainer } from 'react-hot-loader';
import {Provider} from 'react-redux';
import initStore from './config/store';
import setupAxiosInterceptors from './config/axios-interceptor';
import { ToastContainer, toast } from 'react-toastify';
import AppComponent from './app';

setupAxiosInterceptors(() => console.log(''));
const store = initStore();

const render = Component =>
  ReactDOM.render(
    <>
      <ToastContainer
        position={toast.POSITION.TOP_RIGHT}
        className="toastify-container"
        toastClassName="toastify-toast"
      />
      <Suspense fallback={null}>
        <AppContainer>
          <Provider store={store}>
            <div>
              <Component />
            </div>
          </Provider>
        </AppContainer>
      </Suspense>
    </>
    ,
    document.getElementById("root")
  );

render(AppComponent);
